import Title_ru_RU from '@/core/misc/decorators/Title_ru_RU';
import TYPES       from '@/core/services/Changelogs/types';

/**
 * ЦФО (Центр финансовой ответственности)
 * Таблица: oracle.sw_costscenters
 */
class SWCostscenter {

    /* Идентификатор */
    public id: number;

    /* Код договора ЦФО */
    @Title_ru_RU('Код ЦФО', TYPES.STRING)
    public contract: string;

    /* Наименование ЦФО */
    @Title_ru_RU('Наименование ЦФО', TYPES.STRING)
    public name: string;

    static fromServer(data: any, result = new SWCostscenter()): SWCostscenter {
        result.id       = data.id;
        result.contract = data.contract;
        result.name     = data.name;
        return result;
    }

    /**
     * Захардкоженный список ЦФО для платежей образцов
     * (ЮЛ покупателя = ЛСЗ, площадка = "Бердск. Участок разработок")
     * TODO: заменить id на реальные после уточнения
     */
    static getSamplesPaymentList(): SWCostscenter[] {
        return [
            SWCostscenter.fromServer({ id: null, contract: 'ЦО_GAM',         name: 'СТМ Производство ЦФО' }),
            SWCostscenter.fromServer({ id: null, contract: 'ЦО_ОП_FMCG_СНГ', name: 'Отдел продаж FMCG/Drogerie (СНГ Новые технологии) ЦФО' }),
            SWCostscenter.fromServer({ id: null, contract: 'ЦО_ЛАБ_ДМ_П',    name: 'Лаборатория ДМ пищевое направление ЦФО' }),
            SWCostscenter.fromServer({ id: null, contract: 'ЦО_МЕГАБИОМ',    name: 'Мегабиом ритейл ЦФО' }),
        ];
    }

    toString(): string {
        return this.name;
    }
}

export default SWCostscenter;
